import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TablaCuenta from './TablaCuenta'
import TablaDomicilio from './TablaDomicilio';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding:0,
    marginLeft:.6+'rem',
  },
}));

export default function SimpleTabs({ordenBusq,  }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Box  >
      <AppBar position="static" color="transparent"  >
        <Tabs 
          value={value} onChange={handleChange}
          aria-label="simple tabs example" indicatorColor="secondary"
          textColor="secondary" centered                        
        >
          <Tab label="Domicilio" {...a11yProps(0)} />
          <Tab label="Cuenta" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      </Box>
      <TabPanel value={value} index={0} >
        <TablaDomicilio orden={ordenBusq}  />
      </TabPanel>
      <TabPanel value={value} index={1} >
        <TablaCuenta orden={ordenBusq}/>
      </TabPanel>
    </div>
  );
}